import axiosApi from '@klinx/utils/api/axios-api.js';
import db from '@klinx/utils/localstorage';

const apiList = {
  generateId: {
    method: 'GET',
    url: '/authority/common/generateId'
  },
  // 获取当前系统指定枚举
  enums: {
    method: 'GET',
    url: `/oauth/enums`
  },
  // 根据类型编码查询字典项
  codes: {
    method: 'GET',
    url: `/oauth/dictionary/codes`
  },
  // 根据设备类别，查询设备类型
  list: {
    method: 'GET',
    url: `/tenant/deviceType/listByCategory`
  }
};

export default {
  uploadFile: `${process.env.VUE_APP_DEV_REQUEST_DOMAIN_PREFIX}${process.env.VUE_APP_BASE_API}/file/attachment/upload`,
  enums(data) {
    return axiosApi({
      method: 'GET',
      url: `/oauth/enums`,
      data
    });
  },
  export(url, data) {
    return axiosApi({
      method: 'POST',
      url: url,
      responseType: 'blob',
      data
    });
  },
  loadImg(data) {
    const token = db.get('TOKEN', '');
    const tenant = db.get('TENANT', '');
    return `${process.env.VUE_APP_DEV_REQUEST_DOMAIN_PREFIX}${process.env.VUE_APP_BASE_API}/file/attachment/download/${data.bizType}/${data.bizId}?token=${token}&tenant=${tenant}`;
  },
  // 生成id
  generateId(data) {
    return axiosApi({
      ...apiList.generateId,
      data
    });
  },
  // 查询附件
  getAttachment(data) {
    return axiosApi({
      url: '/file/attachment',
      method: 'get',
      data
    });
  },
  // 删除附件
  deleteAttachment(data) {
    return axiosApi({
      url: '/file/attachment',
      method: 'delete',
      data
    });
  },
  // 下载附件
  downloadAttachment(data) {
    return axiosApi({
      url: `/file/attachment/download`,
      method: 'get',
      responseType: 'blob',
      data
    });
  },
  // 根据业务类型/业务id打包下载
  downloadAttachmentBiz(data) {
    return axiosApi({
      url: `/file/attachment/download/biz`,
      method: 'get',
      responseType: 'blob',
      data
    });
  },
  // 获取当前系统指定枚举
  getEnums(data) {
    return axiosApi({
      ...apiList.enums,
      formData: true,
      data
    });
  },
  // 根据类型编码查询字典项
  getDictCodes(data) {
    return axiosApi({
      method: 'GET',
      ...apiList.codes,
      data
    });
  },
  // 根据设备类别，查询设备类型
  getListByCategory(data) {
    return axiosApi({
      method: 'GET',
      ...apiList.list,
      data
    });
  },
  // 获取启用的单位列表
  getUnitList(data) {
    return axiosApi({
      url: `/tenant/unit/list`,
      method: 'get',
      data
    });
  }
};
